<template>
  <div class="layout">
    <div class="venue page w1200">
      <div class="crumbs_warp">
        <ul class="crumbs">
          <li>
            <router-link to="/">首页 ></router-link>
          </li>
          <li>
            <router-link to="/venue">订场馆 ></router-link>
          </li>
          <li>
            <div>{{ detailsInfo.name }}</div>
          </li>
        </ul>
      </div>
      <div class="video_warp">
        <div class="venue_top">
          <div class="general_details_title">
            {{ detailsInfo.name }}
          </div>
        </div>
        <!-- 播放器 -->
        <div v-if="videoUrl">
          <video-player :videoUrl="videoUrl"></video-player>
        </div>
      </div>
      <!-- 简介 -->
      <div class="introduction">
        <div class="item">
          <div class="general_label">
            <i></i>
            <div>简介</div>
          </div>
          <div class="item_content" v-html="detailsInfo.content"></div>
        </div>
        <div class="about_photo">
          <div class="general_label">
            <i></i>
            <div>相关图片</div>
          </div>
          <div class="swiper">
            <swiper v-viewer :options="swiperOption" ref="swiper">
              <swiper-slide v-for="(item, index) in photoList" :key="index">
                <div class="item_img">
                  <img :src="item.image" alt="" :data-original="item.url" />
                </div>
                <div class="item_name">
                  {{ item.name }}
                </div>
              </swiper-slide>
              <div class="swiper_prev" slot="button-prev">
                <img src="@/assets/img/common/prev.png" alt="" />
              </div>
              <div class="swiper_next" slot="button-next">
                <img src="@/assets/img/common/next.png" alt="" />
              </div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videoPlayer from '@/components/videoPlayer'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/assets/css/details.css'
import { getVenueDetails, getVenuePhotos } from '@/api/venue.js'

export default {
  components: {
    videoPlayer,
    swiper,
    swiperSlide
  },
  metaInfo() {
    return {
      title: `${this.detailsInfo.name} - 定场馆 - 周至公共文化云 `
    }
  },
  data() {
    return {
      videoUrl: '',
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper_next',
          prevEl: '.swiper_prev'
        }
      },
      detailsInfo: {},
      photoList: []
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.getVenueDetails()
    this.getVenuePhotos()
  },
  methods: {
    async getVenueDetails() {
      const res = await getVenueDetails({
        id: this.id
      })
      this.detailsInfo = res
      this.videoUrl = res.url
    },
    async getVenuePhotos() {
      const { content: res } = await getVenuePhotos({
        id: this.id,
        page: 0,
        size: 1000
      })
      this.photoList = res
    }
  }
}
</script>
